import React from "react"

import { WithClassName } from "shared/types/WithClassName"

import { useExternalProductDimensioningModel } from "../../model/useExternalProductDimensioningModel"
import { ExternalDimensioningBaseProductCardConnector } from "./ExternalDimensioningBaseProductCardConnector"
import { ExternalProductDimensioningView } from "./ExternalProductDimensioningView"

export type ExternalProductDimensioningModel = ReturnType<
  typeof useExternalProductDimensioningModel
>

export interface ExternalDimensioningBaseProductCardComponentProps {
  variantKey: string
}

export interface ExternalProductDimensioningProps
  extends ExternalProductDimensioningModel,
    WithClassName {
  baseProductCardComponent?: React.ComponentType<ExternalDimensioningBaseProductCardComponentProps>
}

export const ExternalProductDimensioning = React.memo(
  ({
    baseProductCardComponent:
      BaseProductCardComponent = ExternalDimensioningBaseProductCardConnector,
    ...props
  }: ExternalProductDimensioningProps) => {
    return (
      <ExternalProductDimensioningView
        {...props}
        renderBaseProduct={dimInfo => (
          <BaseProductCardComponent variantKey={dimInfo.label} />
        )}
      />
    )
  }
)
